import React from "react";
import { useSubscriptionCompetitionsContext } from "../context";

const specsData = [
  {
    img: "/assets/images/subscription-competitions/icon-trophy.svg",
    title: "513k+",
    description: <>Winners</>,
  },
  {
    img: "/assets/images/subscription-competitions/icon-prize.svg",
    title: "520k+",
    description: <>Prizes given</>,
  },
  {
    img: "/assets/images/subscription-competitions/icon-gift.svg",
    title: "£123M+",
    description: <>Won</>,
  },
];

const Specs = () => {
  const { lobbyContent } = useSubscriptionCompetitionsContext();

  return (
    <>
      {lobbyContent.totalWinnerCount && lobbyContent.totalPrizeCount && lobbyContent.totalPrizeValue && (
        <>
          <div className="w-full flex justify-center mt-auto">
            <div className={"flex flex-col gap-5 justify-center w-fit"}>
              <div className={"flex gap-1.5 justify-center items-center"}>
                <div
                  className={
                    "text-white/40 font-jost text-[8px] font-medium leading-3 uppercase whitespace-nowrap lg:text-xs lg:leading-3"
                  }>
                  Subscriber competitions stats
                </div>
                <div className={"w-full h-px bg-white/8"} />
              </div>
              <div className="gap-4 font-jost flex items-center lg:gap-8">
                {specsData.map((item, index) => (
                  <React.Fragment key={index}>
                    <div className="flex items-center gap-1.5 lg:gap-2">
                      <img
                        src={item.img}
                        alt="spec-icon"
                        width={48}
                        height={48}
                        className="size-4.5 lg:size-7 shrink-0 opacity-30"
                      />

                      <div className={"flex flex-col items-start"}>
                        <div className="text-white font-jost text-xs font-bold leading-4 lg:text-sm lg:leading-5">
                          {index === 0
                            ? lobbyContent.totalWinnerCount
                            : index === 1
                              ? lobbyContent.totalPrizeCount
                              : lobbyContent.totalPrizeValue}
                        </div>

                        <div className="text-white/60 font-jost text-[10px] font-medium leading-3 lg:text-[13px] lg:leading-[18px]">
                          {item.description}
                        </div>
                      </div>
                    </div>

                    {index < specsData.length - 1 && <div className="w-0.5 h-7 bg-white/10 rounded-full" />}
                  </React.Fragment>
                ))}
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default Specs;
